<template>
    <form class="flex flex-col pt-3 md:pt-8" :class="theme" @submit.prevent="handleSubmit">
        <div class="flex flex-col pt-4">
            <ui-label for="email">
                {{ $t('auth.form.fields.email') }}
            </ui-label>
            <ui-input
                v-model="v$.login.email.$model"
                data-cy="email"
                id="email"
                :class="{ 'form-error': v$.login.email.$error }"
            />
            <div
                :class="{ 'text-default-red': v$.login.email.$error }"
                data-cy="email-error"
                v-if="v$.login.email.required.$invalid && v$.login.email.$error"
            >
                {{ $t('validation.required') }}
            </div>
            <validation-errors :errors="validation.errors.email" v-if="validation.errors" />
        </div>

        <div class="flex flex-col pt-4">
            <ui-label for="password">
                {{ $t('auth.form.fields.password') }}
            </ui-label>
            <ui-input
                v-model="v$.login.password.$model"
                type="password"
                data-cy="login_password"
                id="password"
                :class="{ 'form-error': v$.login.password.$error }"
                autocomplete="off"
            />

            <div
                :class="{ 'text-default-red': v$.login.password.$error }"
                data-cy="password-error"
                v-if="v$.login.password.required.$invalid && v$.login.password.$error"
            >
                {{ $t('validation.required') }}
            </div>
            <validation-errors :errors="validation.errors.password" v-if="validation.errors" />
        </div>

        <p class="text-default-red text-center pt-4" data-cy="form-error-messages" v-if="validation.message">
            {{ validation.message }}
        </p>

        <ui-submit-button data-cy="login_button" class="auth-button" :disabled="processing">
            <span v-if="!processing">
                {{ $t('auth.form.buttons.login') }}
            </span>
            <span v-else>
                {{ $t('auth.form.buttons.logging_in') }}
            </span>
        </ui-submit-button>
    </form>
</template>

<script>
import UiInput from '@/components/ui/Input.vue';
import UiLabel from '@/components/ui/Label.vue';
import UiSubmitButton from '@/components/ui/SubmitButton.vue';
import ValidationErrors from '@/components/ui/ValidationErrors.vue';

import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    components: {
        UiInput,
        UiLabel,
        UiSubmitButton,
        ValidationErrors,
    },
    validations: {
        login: {
            email: {
                required,
            },
            password: {
                required,
            },
        },
    },
    props: ['login', 'validation', 'processing', 'theme'],
    methods: {
        async handleSubmit() {
            if (!(await this.v$.$validate())) return false;

            this.$emit('formSubmit');
        },
    },
};
</script>
